// наполнение страницы "Параметры груза"

import * as React from 'react'
import {FC} from 'react'
import Form, {FormInstance} from 'antd/lib/form'
import InsType from '../ins-type'
import CargoInfo from '../cargo-info'
import {CargoTypes} from '../../types/models/cargo-types'
import {ProgramInfo} from '../../types/models/program-info'

interface CargoParamsPropsInterface {
    form: FormInstance
    cargoTypes: CargoTypes
    programInfo: ProgramInfo
    onValueChange: (fieldName: string | string[]) => void
}

const {Item} = Form

const CargoParams: FC<CargoParamsPropsInterface> = ({
    cargoTypes,
    programInfo,
    form,
    onValueChange,
}) => {
    return (
        <div className='e-smart-padding-left'>
            <CargoInfo
                onValueChange={onValueChange}
                cargoTypes={cargoTypes}
                programInfo={programInfo}
                form={form}
            />
            <InsType form={form} onValueChange={onValueChange} />
        </div>
    )
}

export default CargoParams
